import { useFeatureFlagEnabled } from "posthog-js/react";
import { useState } from "react";

import { SOCIAL_PUBLISHING_FLAG } from "@/lib/posthog-flags";

import { useSocialConnection } from "../../hooks/useSocialConnection";

const DISMISSED_KEY = "publishPromoDismissed";

function readDismissed() {
  try {
    return localStorage.getItem(DISMISSED_KEY) === "true";
  } catch {
    return false;
  }
}

export function usePublishPromo(): {
  dismissForever: () => void;
  shouldShow: boolean;
} {
  const isFlagEnabled = useFeatureFlagEnabled(SOCIAL_PUBLISHING_FLAG) === true;
  const [isDismissed, setIsDismissed] = useState(readDismissed);
  const { data: connection } = useSocialConnection({
    enabled: isFlagEnabled && !isDismissed,
  });

  const dismissForever = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, "true");
    } catch {
      // Storage can be unavailable (private mode); the promo just shows again.
    }
    setIsDismissed(true);
  };

  return {
    dismissForever,
    shouldShow:
      isFlagEnabled && !isDismissed && connection?.connected === false,
  };
}
